import { axios } from "@v2/shared/api";

const PARTICIPANT_ENDPOINT = "participants";

export default {
  all(per_page, page) {
    return axios.get(PARTICIPANT_ENDPOINT, {
      params: {
        per_page,
        page
      }
    });
  },

  get(id) {
    return axios.get(PARTICIPANT_ENDPOINT + "/" + id);
  },

  updateCompany(id, companyId, data) {
    return axios.put(
      `${PARTICIPANT_ENDPOINT}/${id}/companies/${companyId}`,
      data
    );
  },

  updateLogo(id, companyId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${id}/companies/${companyId}/logo`,
      data,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },

  chatMessagesRead(id, orderId) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${id}/additional-orders/${orderId}/messages/read-all`
    );
  },

  removeLogo(id, companyId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${id}/companies/${companyId}/logo`
    );
  },

  createParticipantUser(id, data) {
    return axios.post(`${PARTICIPANT_ENDPOINT}/${id}/users`, data);
  },

  updateParticipantUser(id, userId, data) {
    return axios.put(`${PARTICIPANT_ENDPOINT}/${id}/users/${userId}`, data);
  },

  deleteParticipantUser(id, userId) {
    return axios.delete(`${PARTICIPANT_ENDPOINT}/${id}/users/${userId}`);
  },

  getSubParticipants(id) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/sub-participants`);
  },

  getContracts(id) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/contracts`);
  },

  getParticipantOrders(id) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/additional-orders`);
  },

  getParticipantOrderMessages(id, order_id) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${id}/additional-orders/${order_id}/messages`
    );
  },

  sendParticipantOrderMessages(id, order_id, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${id}/additional-orders/${order_id}/messages`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );
  },

  downloadDocument(id, documentId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${id}/documents/${documentId}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  downloadFile(id, fileId) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/files/${fileId}/download`, {
      responseType: "arraybuffer"
    });
  },

  getAllParticipants(exhibitionId) {
    return axios.get(PARTICIPANT_ENDPOINT, {
      params: { exhibition_id: exhibitionId }
    });
  },

  makePrimary(id) {
    return axios.put(`${PARTICIPANT_ENDPOINT}/${id}/make-primary`);
  },

  getCounterparties(id) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/counterparties`);
  },

  getExecutors(id) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${id}/executors`);
  },

  setCurrency(id, currency) {
    return axios.put(`${PARTICIPANT_ENDPOINT}/${id}/set-currency`, {
      currency
    });
  }
};
